export enum ErrorType {
  UnknownError = 0,
  Status_504_Gateway_Timout = 504,
  Status_401_Unauthorized = 401,
}



// WEBPACK FOOTER //
// ./src/app/common/error-handler/error-types.enum.ts